const App_Studio_Light = {
    accent: "#DA173D",
    accent_positive: "#357E94",
    accent_negative: "#F4564E",
    background_content: "#FFFFFF",
    background_page: "#FFFFFF",
    body_text: "#101010",
    border: "#DDD",
    border_style: {
        name: "underlined",
        borderWidth: "0px 0px 1px 0px",
        borderStyle: "solid",
        borderRadius: 0,
    },
    button_border: {
        width: "1px",
        color: "#91000D",
        radius: "0px",
    },
    button_capitalization: "uppercase",
    button_background_color: "#DA173D",
    button_text: "#FFFFFF",
    control_border: {
        width: "1px",
        color: "#DDD",
        radius: "0px",
    },
    control_background_color: "#FFFFFF",
    control_text: "#20293D",
    card_margin: "16px",
    card_padding: "8px",
    card_border: {
        width: "1px 1px 1px 1px",
        style: "solid",
        color: "#DDD",
        radius: "0px",
    },
    card_background_color: "#FFFFFF",
    card_box_shadow: "0px 0px 0px rgba(0,0,0,0)",
    card_outline: {
        width: "0px",
        style: "solid",
        color: "white",
    },
    card_header_margin: "0px",
    card_header_padding: "10px",
    card_header_border: {
        width: "1px",
        style: "solid",
        color: "#DDD",
        radius: "0px",
    },
    card_accent: "#E2E2E2",
    card_header_accent: "#E2E2E2",
    card_header_background_color: "#F1F1F1",
    card_header_box_shadow: "0px 0px 0px rgba(0,0,0,0)",
    card_description_background_color: "#FFFFFF",
    card_description_text: "#101010",
    card_description_font_size: "16px",
    card_title_text: "#101010",
    card_title_font_size: "20px",
    card_menu_background_color: "#FFFFFF",
    card_menu_text: "#101010",
    breakpoint_font: "1200px",
    breakpoint_stack_blocks: "700px",
    color_scheme: "light",
    colorway: [
        "#DA173D",
        "#80CFBE",
        "#60BAB6",
        "#F4564E",
        "#FFEEB2",
        "#20293D",
        "#FADDD2",
        "#FFDD68",
        "#357E94",
        "#A1ACC3",
    ],
    colorscale: [
        "#5E0D24",
        "#7E132F",
        "#9E1A3A",
        "#BE2045",
        "#DE2750",
        "#F0315B",
        "#F5496C",
        "#F9617D",
        "#FA7990",
        "#FBA1A3",
    ],
    dbc_primary: "#DA173D",
    dbc_secondary: "#A6A6A6",
    dbc_info: "#00769F",
    dbc_gray: "#ADB5BD",
    dbc_success: "#00CCA4",
    dbc_warning: "#FADD6A",
    dbc_danger: "#F76065",
    font_family: "Inter",
    font_family_header: "Inter",
    font_family_headings: "Inter",
    font_size: "16px",
    font_size_smaller_screen: "12px",
    font_size_header: "24px",
    title_capitalization: "capitalize",
    header_content_alignment: "spread",
    header_margin: "0px 0px 16px 0px",
    header_padding: "0px",
    header_border: {
        width: "0px 0px 0px 0px",
        style: "solid",
        color: "white",
        radius: "0px",
    },
    header_background_color: "#DDDDDD",
    header_controls_background_color: "#F1F1F1",
    header_box_shadow: "none",
    header_text: "#262626",
    heading_text: "#262626",
    hero_background_color: "#DDD",
    hero_border: {
        width: "0",
        style: "solid",
        color: "transparent",
    },
    hero_controls_background_color: "rgba(241, 241, 241, 0.90)",
    hero_controls_label_text: "#464646",
    hero_controls_label_font_size: "14px",
    hero_controls_grid_columns: 4,
    hero_controls_accent: "#C1C1C1",
    hero_title_text: "#262626",
    hero_title_font_size: "48px",
    hero_subtitle_text: "#646464",
    hero_subtitle_font_size: "16px",
    hero_padding: "24px",
    hero_gap: "24px",
    footer_background_color: "#C1C1C1",
    footer_title_text: "#262626",
    footer_title_font_size: "24px",
    tag_background_color: "#F1F1F1",
    tag_text: "#646464",
    tag_font_size: "14px",
    tag_border: {
        width: "1px",
        style: "solid",
        color: "#DDD",
        radius: "0px",
    },
    tooltip_background_color: "#253247",
    tooltip_font_size: "14px",
    tooltip_text: "#FFFFFF",
    top_control_panel_border: {
        width: "1px",
        style: "solid",
        color: "#DDD",
    },
    text: "#101010",
    report_background_content: "#FAFBFC",
    report_background_page: "white",
    report_text: "black",
    report_font_family: "Computer Modern",
    report_font_size: "12px",
    section_padding: "24px",
    section_title_font_size: "24px",
    section_gap: "24px",
};

export default App_Studio_Light;
